import { render, staticRenderFns } from "./giftGallery.vue?vue&type=template&id=e060c404&scoped=true"
import script from "./giftGallery.vue?vue&type=script&lang=js"
export * from "./giftGallery.vue?vue&type=script&lang=js"
import style0 from "./giftGallery.vue?vue&type=style&index=0&id=e060c404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060c404",
  null
  
)

export default component.exports